<template>
  <div class="crudQueryAndFullScreen">
    <div class="pg-clearfix bod-tb" v-if="currentTabToolValue !== 'fullscreen'">
      <queryToolbar
        style="float: left"
        :selectionIds="selectionIds"
        @get-table-row="getTableRow"
        @get-list-top="getListTop"
        :tableRowMenu="tableRowMenu"
        :urlRemove="urlRemove"
        :store="store"
        :buttonsTopKey="buttonsTopKey"
        :buttonsRowKey="buttonsRowKey"
        :queryToolbarMenu="queryToolbarMenu"
        :routerEdit="routerEdit"
        :extendData="extendData1"
        :buttonMenuListUrl="buttonMenuListUrl"
      >
      </queryToolbar>
      <div class="pg-query-model-buttons pg-clearfix" v-if="queryList && queryList.length > 0">
        <span
          v-for="(item, index) in queryList"
          :key="index"
          :id="buttonMenuListUrl + '_' + item.id"
          class="pg-box-button"
          :class="{ active: item.id == detailModel }"
          @click="changeModel(item.id)"
        >
          <Icon v-if="item.icon" class="icon" :style="item.iconStyle" :custom="item.icon" />
          <span>{{ item.name }}</span>
        </span>
      </div>
    </div>
    <!-- 需求6870：发票管理-顶部提交-需要展示错误提示 -->
    <div v-if="responseData" class="remind-con">
      <newTopRemind :showHandleBtn="false" :value="responseData"></newTopRemind>
    </div>

    <Row class="bod-tb2">
      <Col span="14" class="pg-query-toolbar-left2">
        <Badge
          type="error"
          class-name="demo-badge-alone"
          :count="rowMenu.num"
          v-for="(rowMenu, menuIndex1) in criteriaMenuOfPresetItemsSpit1"
          :key="menuIndex1"
          style="position: relative"
        >
          <a
            href="javascript:void(0)"
            :class="{ active: curItem === rowMenu.id }"
            :id="buttonMenuListUrl + '_' + rowMenu.id"
            @click="
              getCriteriaMenu(rowMenu.id)
              curItem = rowMenu.id
              isActive = false
            "
            class="title-Btn2"
          >
            {{ rowMenu.name }}
          </a>
        </Badge>
        <Dropdown
          trigger="click"
          placement="bottom"
          @on-click="getCriteriaMenu"
          v-if="criteriaMenuOfPresetItemsSpit2.length > 0"
        >
          <a
            href="javascript:void(0)"
            :id="buttonMenuListUrl + '_more'"
            class="title-Btn2"
            :class="{ active: isActive }"
            style="padding-right: 10px"
          >
            更多
            <Icon type="md-arrow-dropdown" style="padding-right: 10px"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(rowMenu, menuIndex1) in criteriaMenuOfPresetItemsSpit2"
              :key="menuIndex1"
              :id="buttonMenuListUrl + '_more_' + rowMenu.id"
              :name="rowMenu.id"
              >{{ rowMenu.name }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown
          trigger="click"
          placement="bottom-start"
          @on-click="getCriteriaMenu"
          v-if="criteriaMenuOfVisibleItems && criteriaMenuOfVisibleItems.length > 0"
        >
          <a
            href="javascript:void(0)"
            :id="buttonMenuListUrl + '_custom'"
            class="title-Btn2"
            style="padding-right: 10px; margin-left: -10px"
          >
            自定义查询组合
            <Icon type="md-arrow-dropdown"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(rowMenu, menuIndex1) in criteriaMenuOfVisibleItems"
              :key="menuIndex1"
              :id="buttonMenuListUrl + '_custom_' + rowMenu.id"
              :name="rowMenu.id"
              >{{ rowMenu.name }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
      <Col span="10" justify="end" class="pg-query-toolbar-right2">
        <div class="tab-tool ivu-row" v-if="ifShowTabTool">
          <TabTool
            v-model="currentTabToolValue"
            :options="tabOptions"
            :styles="{ 'min-width': '90px' }"
            @change="onTabToolChange"
          ></TabTool>
        </div>
        <dynamicFrom
          v-else-if="definitionList"
          :idPrefix="buttonMenuListUrl"
          :options="fromOptions"
          :formProps="propsForm"
          :definitionList="definitionList"
          v-model="page.parameters"
          ref="formRef"
        >
        </dynamicFrom>
      </Col>
    </Row>
    <div class="bod-tb4" ref="groupQueryWrap" v-show="statisticalSearchList.length > 0">
      <groupQuery
        ref="groupQuery"
        :list="statisticalSearchList"
        v-model="page.parameters"
        @changeCriteria="handleChangeCriteria('group')"
      ></groupQuery>
    </div>
    <Row
      class="bod-tb3"
      v-if="
        isShowBtn && queryParamterItemShowItems.length > 0 && currentTabToolValue !== 'fullscreen'
      "
      style="padding-top: 0; padding-bottom: 0"
    >
      <Col span="24">
        <span
          v-for="(item, index) in queryParamterItemShowItems"
          style="margin: 6px 0"
          :key="index"
        >
          {{ item.label }}
          <Tag
            closable
            :id="buttonMenuListUrl + '_close_' + item.property"
            @on-close="handleCloseQueryParamterItemShow(item)"
          >
            {{ item.valueIsObject ? item.value.name : item.value }}
          </Tag>
        </span>
      </Col>
    </Row>
    <div class="pg-table-conetxt pg-clearfix pg-detail-table">
      <slot>
        <slot name="slotTreeClassify" :tableHeight="viewHeight"></slot>
        <div
          class="right-table"
          :class="{
            customEmpty: showCustomEmpty,
            'customEmpty-box': showCustomEmpty && (!data || data.length == 0),
          }"
        >
          <pangu-table
            v-if="ifShowTabTool ? currentTabToolValue !== 'fullscreen' : true"
            :showEmpty="showEmpty"
            v-model="data"
            draggable
            :extendData="extendData1"
            :id="buttonMenuListUrl + '_panguTable'"
            ref="panguTable"
            :total="total"
            :disabled="disabled"
            :selection="selection"
            :indexLabel="indexLabel"
            :pageNo="page.pageNo"
            :pageSize="page.pageSize"
            :table-column-def-url="tableColDefUrl"
            :table-column-def="tableColumnDef"
            :only-show-fields="onlyShowFields"
            @sort-change="(order, sort) => sortChange(order, sort, 'page')"
            @default-sort="(arr) => defaultSort(arr, 'page')"
            :default-sort-val="page.sortings"
            @selection-change="selectionChange"
            @show-summary="showSummaryFn"
            :height="topDomHeight"
          >
            <div slot="empty" v-if="showCustomEmpty" style="text-align: center">
              <div>
                <img src="static/images/icons/blank.png" />
              </div>
              <div style="line-height: 20px; margin-top: -20px">暂无数据，请点击查询</div>
              <Button
                v-if="showEmptyButton"
                type="primary"
                style="padding: 5px 20px; border-radius: 50px; font-size: 14px"
                icon="ivu-icon ivu-icon-icon-pg-serach"
                @click="menuClickOfAdvancedQuery"
              >
                {{ emptyButton }}
              </Button>
            </div>
            <ElTableColumn
              :label="operateCell"
              slot="column-menu"
              v-if="tableRowMenuItem && tableRowMenuItem.length > 0"
              fixed="right"
              width="50px"
              align="center"
            >
              <template slot-scope="scope">
                <Dropdown :transfer="true" @on-visible-change="dropDownVisible(scope.$index)">
                  <a href="javascript:void(0)">
                    <Icon size="17" custom="ivu-icon-icon-pg-operation"></Icon>
                  </a>
                  <DropdownMenu
                    v-if="scope.$index === showDorpDownMenuIndex"
                    slot="list"
                    class="table-row-mun"
                    :class="buttonMenuListUrl + '_panguTable_menu_' + scope.$index"
                  >
                    <DropdownItem
                      v-for="(rowMenu, rowMenuIndex) in tableRowMenuItem"
                      :key="'tableRowMenuItem-' + rowMenuIndex"
                      v-show="computeExpress(rowMenu.showExp, scope.row)"
                    >
                      <buttonForCard
                        v-if="rowMenu.type === 'cardgen'"
                        :store="store"
                        :keyIndex="rowMenuIndex"
                        :rowMenu="rowMenu"
                        :formData="selectionIds"
                        :extendData="{ ...extendData1, rows: [scope.row] }"
                      ></buttonForCard>
                      <Button
                        v-if="!['cardgen'].includes(rowMenu.type)"
                        class="btn"
                        :class="getButtonClass(rowMenu, scope.row, 'ROW')"
                        :custom-icon="convertIcon(rowMenu.icon)"
                        :disabled="!computeExpress(rowMenu.enableExp, scope.row)"
                        @click="handleMenuClickOfRow(scope.$index, scope.row, rowMenu, extendData1)"
                      >
                        {{ rowMenu.name }}
                      </Button>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </ElTableColumn>
          </pangu-table>
          <div v-if="ifShowTabTool ? currentTabToolValue === 'fullscreen' : false">
            <fullscreen
              :urlQuery="screenUrlQuery"
              :getFormItemsDefUrl="getFormItemsDefUrl"
            ></fullscreen>
          </div>
        </div>
        <div
          v-if="ifShowTabTool ? currentTabToolValue !== 'fullscreen' : true"
          class="pg-foter-page"
          :style="{ bottom: bottom }"
        >
          <span
            v-if="cacheSelection"
            class="pg-selected"
            style="margin-right: 50px"
            :style="{ paddingLeft: shrink ? '80px' : '220px' }"
            >已选择<font>{{ extendData1.rows.length }}</font
            >项</span
          >
          <span v-show="queryTime > 0">耗时 : {{ queryTime }}ms</span>
          <Page
            show-sizer
            show-total
            show-elevator
            style="float: right"
            :page-size-opts="pageSizeOption"
            :current.sync="page.pageNo"
            :page-size.sync="page.pageSize"
            :total="page.totalCount"
            placement="top"
            @on-change="pageNoChange"
            @on-page-size-change="pageSizeChange"
          >
          </Page>
        </div>
      </slot>
    </div>
    <crudQueryForSideModal
      v-if="criteriaFormDefData && lazyInitCrudQueryForSideModal"
      title="查询"
      :form-items-def="criteriaFormDefData"
      v-model="page.parameters"
      :show="criteriamodalShow"
      @on-ok="onOkOfCriteria"
      @on-cancel="onCancelOfCriteria"
      @on-update-criteria-menu="onUpdateCriteriaMenu"
      :save-criteria-menu-url="saveCriteriaMenuUrl"
      :selection-menu-url="selectionMenuUrl"
      :get-criteria-menu-url="getCriteriaMenuUrl"
      :delete-criteria-menu-url="deleteCriteriaMenuUrl"
      :statisticalSearchList="statisticalSearchList"
    >
    </crudQueryForSideModal>
    <shuttleBoxModal
      v-if="customColumn && !shuttlegetTableCode"
      v-model="shuttleBoxModal"
      :getParams="shuttlegetParams"
      @on-reset="getTableCol"
      @on-ok="getTableCol"
      :saveParams="shuttleSaveParams"
    ></shuttleBoxModal>
    <shuttleBoxSide
      v-if="customColumn && shuttlegetTableCode"
      v-model="shuttleBoxModal"
      :getParams="shuttlegetParams"
      @on-reset="getTableCol"
      @on-ok="getTableCol"
      :saveParams="shuttleSaveParams"
    ></shuttleBoxSide>
  </div>
</template>
<script>
import { menuCommon, crudQueryMenuClick, buttonClass } from '../mixins/menuClickMixin.js'
import urlUitls from '../../static/js/urlUitls'
import tableDefinitionConverterUtil from '../../static/js/tableDefinitionConverterUtil'
// import moment from "moment";
import { filter } from '../filter'
import objectUtil from '../../static/js/objectUtil'
import queryParamterShowUtils from './queryParamterShowUtils'
import ElTableColumn from '../table/src/table-column'
import CurdQueryStore from './crudQueryStore'
import propsMixin from './propsMixin'
import templateUtil from '../../static/js/templateUtil'
// import groupQuery from './groupQuery.vue'
import groupQuery from './groupQueryDouble.vue'
import { shortcut, setDefaultVal } from './common'
import { TableSort } from '../mixins/tableCommon.js'
import TabTool from './component/TabTool.vue'
const getValue = objectUtil.getValueByPath
export default {
  name: 'crudQueryAndFullScreen',
  mixins: [menuCommon, crudQueryMenuClick, buttonClass, propsMixin],
  components: {
    ElTableColumn,
    groupQuery,
    TabTool,
  },
  props: {
    // 大屏分页数据查询 url
    screenUrlQuery: {
      type: String,
      default: '',
    },
    //
    getFormItemsDefUrl: {
      type: String,
    },
    detailModel: {
      type: [String, Number],
      default: '',
    },
    // 是否显示 Tab 标签
    showTabTool: { type: Boolean, default: false },
    // Tab 选项
    tabOptions: {
      type: Array,
      default() {
        return [
          { name: '列表模式', value: 'list', default: true },
          { name: '大屏模式', value: 'fullscreen' },
        ]
      },
    },
  },
  provide() {
    return {
      parentVue: this,
    }
  },
  data() {
    const store = new CurdQueryStore(
      this,
      this.specialState,
      this.specialMutations,
      this.specialActions
    )
    this.currentRouter = this.$store.state.menuStore.currentRouter
    this.haveCreated = false
    this.cacheExtendData = {}
    return {
      store,
      onlyShowFields: [],
      statisticalSearchList: [],
      extendData1: this.extendData || {},
      lazyInitCrudQueryForSideModal: false, // 查询页面优化加载速度，延迟加载高级查询。
      topDomHeight: 100,
      viewHeight: 100,
      showEmpty: false,
      fromOptions: {
        // 是否启用 未保存提示。
        saveTipFlag: false,
        // 将当前表单对象放到全局对象（globalDataKey)中。便于子类动态(parentGlobalDataKey)表单中获取。
        globalDataKey: null,
        parentGlobalDataKey: 'parentFormData',
      },
      shuttleSaveParams: {
        type: 'LIST',
      },
      shuttlegetTableCode: null,
      shuttleBoxModal: false,
      definitionList: null,
      // 快捷动态表单
      // shortcutFormItems: null,
      selectionIds: [], // 复选框选中对象id数组
      // 列定义
      tableColumnDefData: this.warpColumnDef(this.tableColumnDef),
      // 查询条件定义表单
      criteriaFormDefData: null,

      // 查询条件定义表单是否显示。
      criteriamodalShow: false,
      handleSubmitLoading: false, // 是否请求中
      tableRowMenuItem: null,

      criteriaMenuOfPresetItems: [], // 系统预制
      criteriaMenuOfPresetItemsSpit1: [], // 系统预制,拆分成2部分分开显示
      criteriaMenuOfPresetItemsSpit2: [], // 系统预制,拆分成2部分分开显示
      criteriaMenuOfVisibleItems: null, // 用户自定义

      // 查询条件内容提交后，有值的保存到显示内容中
      queryParamterItemShowItems: [],
      page: {
        parameters: {}, // 高级查询表单
        criteriaCode: '', // 高级查询必填code。
        keyword: '',
        pageNo: 1,
        pageSize: this.getPageSizeCache(),
        totalCount: 0,
        sortings: null,
      },
      panguTableStyle: '',
      total: {},
      isShowSummary: false,
      data: [],
      // 查询
      // 表单Form配置
      propsForm: {
        // 是否开启行内表单模式
        inline: true,
        // 表单域标签的位置，可选值为 left、right、top
        labelPosition: 'right',
        // //表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
        //  labelWidth: 100,
        // 是否显示校验错误信息
        showMessage: true,
        // 原生的 autocomplete 属性，可选值为 off 或 on
        autocomplete: 'off',
      },
      curItem: '',
      isActive: false,
      //权限控制是否显示按钮名称
      showEmptyButton: false,
      pLoading: false, // 表格是否显示加载数据
      // 初始化加载数据，用于高级查询设置分组条件
      isFirst: true,
      showDorpDownMenuIndex: 0,
      queryTime: 0,

      taskArr: this.defaultSlot ? ['sort', 'group', 'criteria'] : ['group', 'criteria'],
      responseData: null, // 接口返回的完整结构体
      // #7135，当前 TabTool 的值
      currentTabToolValue: null,
    }
  },

  watch: {
    // 需求6870：发票管理-顶部提交-需要展示错误提示 ->计算高度
    responseData: function () {
      this.$nextTick(() => this.setTopDomHeight())
    },
    extendData(val) {
      this.extendData1 = val
      if (!this.extendData1) this.extendData1 = {}
      if (!this.extendData1.rows) this.extendData1.rows = []
    },
    urlQueryParamter: {
      handler(val) {
        if (this.GLOBAL.isDebug) console.log('urlQueryParamter', val)
        this.handleChangeCriteria()
      },
      deep: true,
    },
    dynamicParamter: {
      handler() {
        this.handleChangeCriteria()
      },
    },
    criteriaFormUrl() {
      this.getCriteriaFormDefByUrl(this.criteriaFormUrl)
    },
  },
  created() {
    if (this.criteriaFormUrl) {
      // 动态获取高级查询表单,获取初始值后，调用查询
      this.getCriteriaFormDefByUrl(this.criteriaFormUrl)
    } else {
      // 加载数据
      if (this.initialLoad) {
        if (this.getLocalCache()) {
          if (this.taskArr.includes('criteria'))
            this.taskArr.splice(this.taskArr.indexOf('criteria'), 1)
          this.setTopDomHeight()
          if (this.defaultSlot) {
            return
          }
        }
        this.handleChangeCriteria()
      } else {
        this.showEmpty = true
        this.clearCriteria()
        if (this.showCustomEmpty) {
          this.setTopDomHeight()
        } else {
          this.topDomHeight = 100
        }
      }
    }
    if (!this.extendData1) this.extendData1 = {}
    if (!this.extendData1.rows) this.extendData1.rows = []
  },
  computed: {
    tableCode() {
      if (this.tableColCode) {
        return this.tableColCode
      } else if (this.tableColumnDefUrl?.indexOf('tableCode')) {
        return urlUitls.getRequestParamter(this.tableColumnDefUrl).tableCode
      } else {
        return null
      }
    },
    showSummary() {
      return (
        this.tableColumnDefData &&
        this.tableColumnDefData.table &&
        this.tableColumnDefData.table.total
      )
    },
    bottom() {
      //底部copyright信息存在，按钮部分的底部距离为20，如果不存在就是0
      if (this.$store.state.user.system) {
        return '20px'
      } else {
        return 0
      }
    },
    tableColDefUrl() {
      if (this.tableColumnDefUrl) {
        return this.tableColumnDefUrl
      } else if (this.tableColCode) {
        return `${this.tableColDefaultUrl}${this.tableColCode}`
      } else {
        return ''
      }
    },
    shuttlegetParams() {
      return {
        tableCode: this.shuttlegetTableCode ? this.shuttlegetTableCode : this.tableColCode,
      }
    },
    shrink() {
      return objectUtil.getValueByPath(this.$store.state, 'layoutCommon.shrink', false)
    },
    ifShowTabTool() {
      return this.showTabTool && this.tabOptions.length == 2
    },
  },
  methods: {
    // 需求6870：发票管理-顶部提交-需要展示错误提示 -> 返回数据更新到顶部提示信息 接口函数 :updateTopMindReload
    onTableButtonErrors(resData) {
      this.responseData = resData
    },
    //列表点击排序
    sortChange(order, sort, page) {
      TableSort(order, sort, this[page])
      this.handleChangeCriteria()
    },
    defaultSort(arr, page) {
      this[page].sortings = arr
      this.handleChangeCriteria('sort')
    },
    dropDownVisible(index) {
      this.showDorpDownMenuIndex = index
    },
    changeModel(val) {
      this.$cfn.setNeedCache(false, this.currentRouter.id)
      this.$emit('changeModel', val)
    },
    //获取pageSize的缓存
    getPageSizeCache() {
      let temp = localStorage.getItem(
        `${this.currentRouter.id}_${this.detailModel}_crudQuery_pagesize`
      )
      return temp ? Number(temp) : 10
    },
    //设置pageSize的缓存
    setPageSizeCache() {
      localStorage.setItem(
        `${this.currentRouter.id}_${this.detailModel}_crudQuery_pagesize`,
        this.page.pageSize
      )
    },
    // 获取缓存数据
    getLocalCache() {
      // 请求数据前 先判断是否有缓存数据，有，直接使用缓存数据并返回
      if (!this.haveCreated) {
        console.info('这个执行了。。。')
        this.haveCreated = true
        let cacheMemory = this.$cfn.getLocalCacheMemory(
          `${this.currentRouter.id}`,
          this,
          ['data'],
          ['fromOptions', 'propsForm', 'definitionList', 'pLoading', 'taskArr']
        )
        this.extendData1.rows = []
        return cacheMemory
      } else {
        return false
      }
    },
    // 需要使用菜单exportOfCondition 配合获取导出
    getExportOfCondition() {
      var dataOrConfig = null
      this.page[this.searchKey] = this.page.keyword

      // 手动设置查询参数urlQueryParamter
      // urlQueryParamter 是配置的默认参数，取this.page 最新值来合并。 Object.assign有缺陷不支持子对象的属性合并，对于this.urlQueryParamter.parameters和this.page.parameters 2个子属性并不是合并，而是替换。
      if (this.urlQueryParamter) {
        dataOrConfig = Object.assign({}, this.urlQueryParamter, this.page)

        // 特殊处理，手动合并parameters子属性，以this.urlQueryParamter.parameters为默认值。
        if (this.urlQueryParamter.parameters) {
          dataOrConfig.parameters = Object.assign(
            {},
            this.urlQueryParamter.parameters,
            this.page.parameters
          )
        }
      } else {
        dataOrConfig = this.page
      }

      if (this.dynamicParamter && dataOrConfig.parameters) {
        dataOrConfig.parameters = Object.assign(dataOrConfig.parameters, this.dynamicParamter)
      }
      return dataOrConfig
    },
    setTopDomHeight(extra) {
      // TOPDOMHEIGHT等于后面各高度相加(取整)为271：60:顶部高度,29:tab高度,41.45:操作按钮区域的高度,36:自定义查询条件区域高度,44.53:当前高级查询条件显示区域宽度,48:底部分页区域高度,
      // this.queryParamterItemShowItems控制'当前高级查询条件显示区域是否显示'32
      let topDomHeight = this.queryParamterItemShowItems.length > 0 ? 252 : 220,
        documentHeight = document.body.offsetHeight,
        tableHeight = 0
      if (documentHeight < topDomHeight + 200) {
        tableHeight = 100
        // return documentHeight;
      } else {
        tableHeight = documentHeight - topDomHeight
      }

      if (extra) tableHeight += extra
      //20px 版权高度
      if (this.$store.state.user.system) {
        tableHeight = tableHeight - 20
      }
      // 分组 “合并”高度
      if (this.statisticalSearchList.length > 0) {
        tableHeight = tableHeight - 41
      }
      // 需求6870：发票管理-顶部提交-需要展示错误提示 ->展示接口返回errors错误提示信息的高度为 34px
      if (this.responseData?.errors?.length > 0) {
        tableHeight = tableHeight - 34
      }
      //展示表格区域的总高度
      this.viewHeight = tableHeight
      //当有数据时，“当页合计、合计”应跟随表格显示
      //当数据满一屏的时候，表格固定高度，“当页合计、合计”应该固定在底部
      //40是表头行或者一行内容的高度，50是合计行高度
      if (this.data && this.data.length > 0) {
        let practical = 30 + 10 //10是横向滚动条的高度
        if (this.isShowSummary) {
          practical += 50
        }
        if (this.data.length > this.page.pageSize) {
          practical = practical + this.page.pageSize * 30
        } else {
          practical = practical + this.data.length * 30
        }
        if (practical < tableHeight) {
          tableHeight = ''
        }
      }
      this.topDomHeight = tableHeight
      this.$emit('top-dom-height', tableHeight)
    },
    showSummaryFn() {
      this.isShowSummary = true
      this.setTopDomHeight()
    },
    convertIcon(icon) {
      let str = ''
      if (icon && icon != '') {
        str = `ivu-icon-icon-pg-${icon.substr(icon.lastIndexOf('-') + 1)}`
      }
      return str
    },
    // 手动设置 分页缓存选中数据
    setSelectedData(pageRows, pageNo) {
      const hadSelected = this.cacheExtendData[pageNo]
      this.cacheExtendData[pageNo] = []
      this.$nextTick(() => {
        pageRows.forEach((row) => {
          if (
            hadSelected.some(
              (im) => getValue(im, this.selectionKey) === getValue(row, this.selectionKey)
            )
          ) {
            this.$refs.panguTable.toggleRowSelection(row, true)
          }
        })
      })
    },
    // 表格选中数据变化
    selectionChange(selection) {
      if (this.pageChange) {
        this.pageChange = false
        return
      }
      let eSelection = selection
      if (this.cacheSelection) {
        this.cacheExtendData[this.page.pageNo] = selection // 缓存当页的选中数据
        eSelection = []
        Object.keys(this.cacheExtendData).forEach((pageNo) => {
          eSelection.push.apply(eSelection, this.cacheExtendData[pageNo])
        })
      }
      let tempStr = eSelection.map((item) => {
        return objectUtil.getValueByPath(item, this.dataIdKey)
      })
      this.selectionIds = tempStr.join(',')
      // 用于业务判断。
      // 选中数据的id集合两种模式：rowIdsArray（字符串数组），rowIdsString（逗号分隔的字符串）
      let params = {
        rows: eSelection,
        rowIdsArray: eSelection.map((item) => {
          return item.id
        }),
        rowIdsString: eSelection
          .map((item) => {
            return item.id
          })
          .join(','),
      }
      this.extendData1 = Object.assign({}, this.extendData1, params) // 直接修改row不会引起extendData1被监听，引起数据不能传入子组件造成错误
      if (!this.extendData1.rows) this.extendData1.rows = []
      // console.info("selectionChange", eSelection, this.selectionIds, this.extendData1);
    },
    // 兼容前端定义的老模型。
    warpColumnDef(data) {
      if (!data) return data
      tableDefinitionConverterUtil.converterByDictFormData(
        data,
        false,
        this.$store.state.strategy.strategy
      )
      data.items = tableDefinitionConverterUtil.getItemsForFilterVisible(data.items, null, this)
      return data
    },
    // 刷新当前数据
    reload(updateErrors) {
      // 需求6870：发票管理-顶部提交-需要展示错误提示
      if (updateErrors) updateErrors()
      if (this.GLOBAL.isDebug) console.log('crudQuery.reload')
      this.handleChangeCriteria()
    },
    // 高级查询动态表单URL
    getCriteriaFormDefByUrl(criteriaFormUrl) {
      if (!criteriaFormUrl) return
      this.$Loading.start()
      this.$axios
        .get(criteriaFormUrl)
        .then((res) => {
          this.$Loading.finish()
          if (!this.$cfn.ajax1.isOK(res, this)) return
          this.criteriaFormDefData = res.data.data

          // 统计方式查询数组
          this.statisticalSearchList = res.data.data.groups || []

          // 设置查询条件初始值，根据查询条件定义的缺省值配置
          this.page.criteriaCode = this.criteriaFormDefData.criteria.code

          let tempKey = this.cacheQueryKey ? this.cacheQueryKey : this.$route.name
          let key = tempKey + this.detailModel + '_crud_query_parameter'
          let parameter = sessionStorage.getItem(key)
          //没有查询条件时设置缺省值
          if (!parameter) {
            this.setPageParametersByCriteriaFormDef(this.criteriaFormDefData)
          }

          // 设置查询条件初始值，根据查询条件定义的缺省值配置
          this.setByShortcutFormCriteriaFormDef(this.criteriaFormDefData)

          // 判断是否有缓存，使用缓存
          if (this.getLocalCache()) {
            if (this.taskArr.includes('criteria'))
              this.taskArr.splice(this.taskArr.indexOf('criteria'), 1)
            this.setTopDomHeight()
            if (this.defaultSlot) {
              return
            }
          }

          // 初始化自定义条件
          this.initCriteriaMenu(this.criteriaFormDefData.criteria.id)

          // 表单值更新到查询内容显示区域
          this.getQueryParamterItemShowItemsOf()
        })
        .catch((res) => {
          this.$Loading.error()
          this.$cfn.ajax1.catch1(res, this)
        })
    },
    // 设置查询条件初始值，根据查询条件定义的缺省值配置
    setPageParametersByCriteriaFormDef(criteriaFormDefData) {
      this.page.parameters = setDefaultVal(criteriaFormDefData)
    },
    //恢复默认值
    restoreCriteria() {
      // 首先将快捷查询部分的条件与侧滑部分的查询条件重新组合在一起
      this.criteriaFormDefData.items = [...this.criteriaFormDefData.items, ...this.definitionList]
      // 设置所有查询条件初始值，根据查询条件定义的缺省值配置
      // 统计方式查询数组
      this.statisticalSearchList = this.criteriaFormDefData.groups || []
      this.$refs.groupQuery.init(this.statisticalSearchList)
      this.setPageParametersByCriteriaFormDef(this.criteriaFormDefData)
      // 设置快捷查询表单中一些组件的样式与操作
      this.setByShortcutFormCriteriaFormDef(this.criteriaFormDefData)
      // 高级查询条件组装完毕，请求数据
      this.handleChangeCriteria()
    },

    // 设置查询条件初始值，根据查询条件定义的缺省值配置
    setByShortcutFormCriteriaFormDef(criteriaFormDefData) {
      this.definitionList = shortcut(
        criteriaFormDefData,
        () => {
          this.page.pageNo = 1
          this.handleChangeCriteria('criteria')
        },
        this
      )
    },

    getTableRow(val) {
      this.tableRowMenuItem = val
    },
    getListTop(listTopMenus) {
      //当在按钮列表里面找到调用“menuClickOfAdvancedQuery”方法的按钮时，认为它是高级查询按钮，
      if (listTopMenus && listTopMenus.length > 0) {
        listTopMenus.forEach((listTopMenu) => {
          if (
            objectUtil.getValueByPath(listTopMenu, 'param.methodName') == 'menuClickOfAdvancedQuery'
          ) {
            this.showEmptyButton = true
          }
        })
      }
    },
    getProgressTask(progressTask) {
      const urlProgress = this.urlProgress
      return new Promise((resolve, reject) => {
        const getProgress = (urlProgress, data) => {
          this.$axios
            .get(urlProgress, { params: data })
            .then((res) => {
              if (!this.$cfn.ajax1.isOK(res, this)) return
              const _data = res.data.data
              const statusCode = _data.status.code
              if (statusCode === 'WAIT' || statusCode === 'DOING') {
                setTimeout(() => {
                  getProgress(urlProgress, { id: _data.id })
                }, 1000)
              } else if (statusCode === 'ERROR') {
                reject(_data.message)
              } else {
                const resData = res.data.data?.data ? JSON.parse(res.data.data?.data) : []
                resolve(resData)
              }
            })
            .catch((err) => {
              if (document.leadLoad) {
                document.leadLoad.cancel()
                delete document.leadLoad
              }
              this.$cfn.ajax1.catch1(err, this)
              reject(err)
            })
        }
        getProgress(urlProgress, { id: progressTask.id })
      })
    },
    getData() {
      // 配置了高级查询情况下，需要等下高级查询相关数据设置完成后，才能查询
      if (this.criteriaFormUrl && !this.criteriaFormDefData) {
        if (this.GLOBAL.isDebug) console.log('criteriaFormDefData is null.loading')
        return
      }

      if (this.GLOBAL.isDebug) console.log('this.page', this.page.pageNo, this.page.pageSize)
      var dataOrConfig = this.getExportOfCondition()

      // 可以处理“排序”-默认带好我们的tableCode才能排序
      if (!dataOrConfig['tableCode']) dataOrConfig['tableCode'] = this.tableCode

      this.setOnlyShowFields(dataOrConfig.parameters) //计算分组的表格列字段
      this.setCriteriaQuery(dataOrConfig.parameters) //将查询条件存入sessionStorage
      // 存在slot的情况下
      if (!this.defaultSlot) {
        this.$emit('get-data', dataOrConfig, this.statisticalSearchList)
        return
      }

      // 开始请求数据
      var tmpurl = this.urlQuery
      if (this.urlQueryMethod == 'get') {
        tmpurl += tmpurl.indexOf('?') > -1 ? '&' : '?'
        tmpurl += urlUitls.paramSerializer(dataOrConfig)
      }
      this.$Loading.start()
      if (!document.leadLoad) {
        document.leadLoad = this.$pgMessage.leadLoading({
          loadingText: '请求中...',
          terminationText: '请求成功',
          isBody: false,
        })
      }
      this.data = []
      this.queryTime = 0
      const queryBefore = Date.now()
      this.$axios[this.urlQueryMethod](tmpurl, dataOrConfig)
        .then(async (res) => {
          this.isFirst = false
          this.$Loading.finish()
          //    this.$Loading.error();
          if (!this.$cfn.ajax1.isOK(res, this)) {
            if (document.leadLoad) {
              document.leadLoad.cancel()
              delete document.leadLoad
            }
            this.setTopDomHeight()
            return
          }

          const resData = res.data.progressTask
            ? await this.getProgressTask(res.data.progressTask)
            : res.data
          // 100条数据，增加Object.freeze该方法后，90M 优化到80M左右。打版本到iscc对比有显著提高：销售单， 10条数据。（35M比91M）。40条数据：68M比222M
          // var freezeData = res.data.data || []

          var freezeData = []
          // 解决明细模式下,数据id为单据id导致表格唯一键名重复问题
          if (resData.data?.length > 0) {
            freezeData = resData.data.map((im) => {
              im['_ID'] = objectUtil.createID()
              return im
            })
          }
          // 解决删除时，最后一条数据或是批量删除完时，有数据，但是，页面没有数据显示的情况
          const { totalCount } = resData
          if (totalCount > 0 && freezeData.length === 0 && this.page.pageNo > 1) {
            this.page.pageNo = this.page.pageNo - 1
            this.handleChangeCriteria()
            return
          }
          // objectUtil.deepFreeze(freezeData);
          this.data = freezeData
          if (this.needSideParams) {
            this.data.forEach((item) => {
              item.params = this.page.parameters
            })
          }
          this.page.totalCount = resData.totalCount
          this.page.pageSize = resData.pageSize
          this.total = resData.total
          this.$nextTick(() => {
            if (document.leadLoad) {
              document.leadLoad.cancel()
              delete document.leadLoad
            }
          })
          if (this.cacheSelection) {
            // 分页选中数据缓存，执行
            const pageNo = this.page.pageNo
            const cData = this.cacheExtendData[pageNo]
            if (cData && cData.length > 0) this.setSelectedData(this.data, pageNo)
          }
          // 表单值更新到查询内容显示区域
          this.getQueryParamterItemShowItemsOf()
          if (!this.data || this.data.length <= 0) {
            this.showEmpty = true
            if (this.showCustomEmpty) {
              this.setTopDomHeight()
            } else {
              this.topDomHeight = 100
            }
          } else {
            this.setTopDomHeight()
          }
        })
        .catch((res) => {
          this.$cfn.ajax1.catch1(res, this)
          this.$Loading.error()
          if (document.leadLoad) {
            document.leadLoad.cancel()
            delete document.leadLoad
          }
        })
        .finally(() => {
          this.queryTime = Date.now() - queryBefore
        })
    },
    // 动态菜单，点击方法-高级查询
    menuClickOfAdvancedQuery() {
      if (!this.criteriaFormUrl) {
        this.$Message.error('未配置高级查询查询：criteriaFormUrl')
        return
      }

      if (!this.criteriaFormDefData) {
        // this.$Modal.error(config)
        this.$Message.error('请稍后，等待高级查询表单加载')
        return
      }

      if (!this.lazyInitCrudQueryForSideModal) this.lazyInitCrudQueryForSideModal = true
      this.criteriamodalShow = !this.criteriamodalShow
    },

    setOnlyShowFields(formData) {
      // console.log("setOnlyShowFields",formData);
      var onlyShowFields = []
      for (var i = 0; i < this.statisticalSearchList.length; i++) {
        var item = this.statisticalSearchList[i]
        if (
          formData[item.property] &&
          item.parameter &&
          Array.isArray(item.parameter.onlyShowFields)
        ) {
          onlyShowFields = onlyShowFields.concat(item.parameter.onlyShowFields)
        }
      }
      this.onlyShowFields = onlyShowFields
    },
    //刷新按钮，需要将pageNo置为1
    pageNoOneReload() {
      this.page.pageNo = 1
      this.handleChangeCriteria()
    },
    onOkOfCriteria(formData) {
      this.page.parameters = Object.assign(this.page.parameters, formData)
      // this.$set(this.page, "parameters", formData);
      this.page.pageNo = 1
      this.handleChangeCriteria('criteria')
      this.curItem = '' // 清空选中
      this.criteriamodalShow = false
    },
    onCancelOfCriteria() {
      if (this.GLOBAL.isDebug) console.log('onCancel')
      this.criteriamodalShow = false
    },
    pageNoChange() {
      // 此处因为如果有选中数据，在进入新的分页时会执行，selectionChange 事件 引起缓存数据丢失，故设置 标志 过滤此操作
      if (this.extendData1.rows.length > 0) this.pageChange = true
      this.handleChangeCriteria()
    },
    pageSizeChange(index) {
      if (index === undefined) {
        return
      }
      this.cacheExtendData = {}
      this.page.pageSize = index
      this.setPageSizeCache()
      this.handleChangeCriteria()
    },
    //在初始不加载数据的情况下需要等待taskArr中其他两项已清空的情况下才能情空criteria
    clearCriteria() {
      if (this.taskArr.includes('criteria') && this.taskArr.length > 1) {
        setTimeout(() => {
          this.clearCriteria()
        }, 500)
      } else {
        if (this.taskArr.includes('criteria'))
          this.taskArr.splice(this.taskArr.indexOf('criteria'), 1)
      }
    },
    //获取sessionStorage的查询条件
    getCriteriaQuery() {
      if (!this.ifCacheQuery) {
        if (!this.initialLoad) {
          this.clearCriteria()
          this.showEmpty = true
          if (this.showCustomEmpty) {
            this.setTopDomHeight()
          } else {
            this.topDomHeight = 100
          }
        } else {
          this.handleChangeCriteria('criteria')
        }
        return
      }
      let tempKey = this.cacheQueryKey ? this.cacheQueryKey : this.$route.name
      let key = tempKey + this.detailModel + '_crud_query_parameter'
      let parameter = sessionStorage.getItem(key)
      parameter = JSON.parse(parameter)
      let temp = Object.assign({}, this.page.parameters, parameter)
      this.$set(this.page, 'parameters', temp)
      this.getQueryParamterItemShowItemsOf()
      if (!this.initialLoad) {
        if (parameter && Object.keys(parameter).length !== 0) {
          this.handleChangeCriteria('criteria')
        } else {
          this.clearCriteria()
          this.showEmpty = true
          if (this.showCustomEmpty) {
            this.setTopDomHeight()
          } else {
            this.topDomHeight = 100
          }
        }
      } else {
        this.handleChangeCriteria('criteria')
      }
    },
    //查询条件存入sessionStorage
    setCriteriaQuery(data) {
      if (!data && !this.ifCacheQuery) return
      let tempKey = this.cacheQueryKey ? this.cacheQueryKey : this.$route.name
      let key = tempKey + this.detailModel + '_crud_query_parameter'
      sessionStorage.setItem(key, JSON.stringify(data))
    },

    onUpdateCriteriaMenu() {
      this.getSelectionMenuItem(
        {
          preset: false,
          criteria: this.criteriaFormDefData.criteria.id,
          visible: true,
        },
        (res) => {
          this.criteriaMenuOfVisibleItems = res.data.data
        }
      )
    },

    // 初始化自定义条件
    initCriteriaMenu(criteriaId) {
      this.getSelectionMenuItem(
        {
          preset: true,
          criteria: criteriaId,
        },
        (res) => {
          this.criteriaMenuOfPresetItems = res.data.data
          // 拆分成2部分分开显示
          this.criteriaMenuOfPresetItemsSpit1 = []
          this.criteriaMenuOfPresetItemsSpit2 = []
          let defaultQueryId = this.$route.query.defaultQueryId
          let defaultQueryParameters = this.$route.query.defaultQueryParameters
          let isDefaultQueryId = false
          for (var i = 0; i < this.criteriaMenuOfPresetItems.length; i++) {
            // 修复如果查询条件 再更多里面，没有执行查询
            if (defaultQueryId && this.criteriaMenuOfPresetItems[i].id == defaultQueryId) {
              isDefaultQueryId = true
            }
            if (i < this.criteriaMenuOfPresetItemsSpitSize) {
              this.criteriaMenuOfPresetItemsSpit1.push(this.criteriaMenuOfPresetItems[i])
            } else {
              this.criteriaMenuOfPresetItemsSpit2.push(this.criteriaMenuOfPresetItems[i])
            }
          }
          if (isDefaultQueryId) {
            this.taskArr.splice(this.taskArr.indexOf('criteria'), 1)
            this.getCriteriaMenu(defaultQueryId)
            this.curItem = defaultQueryId
            delete this.$route.query.defaultQueryId
          } else if (defaultQueryParameters) {
            //设置初始默认查询条件
            try {
              defaultQueryParameters =
                typeof defaultQueryParameters == 'object'
                  ? defaultQueryParameters
                  : // : JSON.parse(defaultQueryParameters)
                    eval('(' + defaultQueryParameters + ')')
              this.page.parameters = Object.assign({}, this.page.parameters, defaultQueryParameters)
              this.taskArr.splice(this.taskArr.indexOf('criteria'), 1)
              this.handleChangeCriteria()
              delete this.$route.query.defaultQueryParameters
            } catch (error) {
              console.error(error.message, defaultQueryParameters)
            }
          } else {
            this.getCriteriaQuery()
          }
        }
      )

      this.onUpdateCriteriaMenu()
    },

    /*
            criteria
            查询表id

            keyword
            关键词

            visible
            是否可见

            preset
            是否预置字段
            */

    getSelectionMenuItem(param, callbackFN) {
      var tmpurl = this.selectionMenuUrl

      /*
                getSelectionMenuItem (criteriaId,preset,visible,callbackFN) {
                var param={
                    preset:preset,
                    criteria:criteriaId,
                    visible:visible
                };
            */

      //  var param=Object.assign(this.$route.query,param);
      tmpurl += tmpurl.indexOf('?') > -1 ? '&' : '?'
      tmpurl += urlUitls.paramSerializer(param)

      this.$axios
        .get(tmpurl)
        .then((res) => {
          if (!this.$cfn.ajax1.isOK(res, this)) return
          if (typeof callbackFN === 'function') {
            callbackFN(res)
          }
          //  this.criteriaMenu = res.data.data;
        })
        .catch((res) => {
          this.$cfn.ajax1.catch1(res, this)
        })

      return tmpurl
    },
    // dropdownMenuPresetOnClick:function(name){
    //        if(this.GLOBAL.isDebug)console.log("dropdownMenuPresetOnClick",name);
    //     for(var i=0;i<this.criteriaMenuOfPresetItems.length;i++){
    //           if(name==this.criteriaMenuOfPresetItems[i].name){
    //               getCriteriaMenu(this.criteriaMenuOfPresetItems[i].id);
    //           }
    //     }
    // },
    // dropdownMenuVisibleOnClick:function(name){
    //     for(var i=0;i<this.criteriaMenuOfPresetItems.length;i++){
    //           if(name==this.criteriaMenuOfVisibleItems[i].name){
    //               getCriteriaMenu(this.criteriaMenuOfVisibleItems[i].id);
    //           }
    //     }
    // },
    getCriteriaMenu(id) {
      if (!id) {
        return
      }
      if (!this.getCriteriaMenuUrl) {
        this.$Message.error('getCriteriaMenuUrl is null')
        return
      }
      if (this.criteriaMenuOfPresetItemsSpit2.some((im) => im.id === id)) {
        // 查询条件不在更多里面，更多高亮了。。
        this.isActive = true
      }
      this.curItem = ''
      var tmpurl = this.getCriteriaMenuUrl
      tmpurl += tmpurl.indexOf('?') > -1 ? '&' : '?'
      tmpurl += 'id=' + id

      this.$Loading.start()
      this.$axios
        .get(tmpurl)
        .then((res) => {
          this.$Loading.finish()
          if (!this.$cfn.ajax1.isOK(res, this)) return
          var criteriaMenu = res.data.data
          if (criteriaMenu.parameter) {
            for (let item in criteriaMenu.parameter) {
              if (
                criteriaMenu.parameter[item] &&
                typeof criteriaMenu.parameter[item] === 'string' &&
                criteriaMenu.parameter[item].indexOf('$today') != -1
              ) {
                let nowTime = new Date().getTime()
                // YYYY-MM-DD HH:mm:ss
                criteriaMenu.parameter[item] = filter(nowTime, 'date', 'YYYY-MM-DD')
                //  moment(nowTime).format(
                //     "YYYY-MM-DD"
                // );
              }
            }
          }
          // 当点击了自定义查询条件后，手动将已经选中的分组条件重新放入查询条件中
          //  如果有分组条件就放进去，如果没有，就不放
          if (
            this.statisticalSearchList &&
            Array.isArray(this.statisticalSearchList) &&
            this.statisticalSearchList.length > 0
          ) {
            this.statisticalSearchList.forEach((im) => {
              if (this.page.parameters[im.code])
                criteriaMenu.parameter[im.code] = this.page.parameters[im.code]
            })
          }
          this.page.parameters = criteriaMenu.parameter
          this.page.pageNo = 1
          this.handleChangeCriteria()
        })
        .catch((res) => {
          this.$Loading.error()
          this.$cfn.ajax1.catch1(res, this)
        })
    },

    isShowParamterItemShowItemsValue(value) {
      var showFlag = false
      if (Array.isArray(value)) {
        if (value.length == 0) return false
        // 数组里有非空，则为true
        for (let item of value) {
          if (item || item === false) {
            showFlag = true
          }
        }
        return showFlag
      }
      // boolean值为false或者0也表示有值
      if (value === false || value === 0) return true

      if (value === '' || value === null || value === undefined) {
        return false
      }

      return !!value
    },

    // 将查询条件有内容的数据放到快捷显示区域
    getQueryParamterItemShowItemsOf() {
      var parameters = this.page.parameters

      //将查询参数放在扩展参数内
      if (!this.extendData1) this.extendData1 = {}
      if (!this.extendData1.parameters) this.extendData1.parameters = {}
      this.extendData1.parameters = parameters

      var criteriaFormDefData = this.criteriaFormDefData

      if (!parameters || !criteriaFormDefData) {
        if (this.GLOBAL.isDebug)
          console.log(
            'getQueryParamterItemShowItemsOf,parameters,criteriaFormDefData',
            parameters,
            criteriaFormDefData
          )
        return
      }
      var newitems = []
      var items = criteriaFormDefData.items
      if (!items) return
      for (var i = 0; i < items.length; i++) {
        var item = items[i]

        if (!parameters.hasOwnProperty(item.property)) continue
        var value = parameters[item.property]
        // if(value===''||value===null||value== undefined)continue;
        if (!this.isShowParamterItemShowItemsValue(value)) continue

        var newitem = {}
        newitem.label = item.label
        newitem.property = item.property
        newitem.value = queryParamterShowUtils.getParamterShowValue(value, item)
        // 支持对象显示name(valueIsObject为true, 显示obj的name)
        if (
          typeof newitem.value == 'object' &&
          newitem.value &&
          newitem.value.hasOwnProperty('name')
        ) {
          newitem.valueIsObject = true
        } else {
          newitem.valueIsObject = false
        }
        newitems.push(newitem)
      }

      this.queryParamterItemShowItems = newitems

      return newitems
    },

    // 显示查询条件内容面板
    handleCloseQueryParamterItemShow(item) {
      this.curItem = '' // 清空选中，bug 14141
      this.isActive = '' // 清空选中，bug 14145
      this.page.parameters[item.property] = null // 直接delete不会触发vue的监听机制
      delete this.page.parameters[item.property]
      this.handleChangeCriteria()
    },
    //触发自定义列表字段方法
    shuttleBoxModalShow(menuParameter, data) {
      if (menuParameter && menuParameter.param && menuParameter.param.tableCode) {
        let shuttlegetTableCode = templateUtil.compileData(menuParameter.param.tableCode, data)
        this.shuttlegetTableCode = shuttlegetTableCode
      }
      this.shuttleBoxModal = true
    },
    getTableCol() {
      if (this.$refs && this.$refs.panguTable)
        this.$refs.panguTable.getTableColumnDefByUrl(this.tableColDefUrl)
    },
    handleChangeCriteria(flag) {
      if (flag) {
        this.taskArr.splice(this.taskArr.indexOf(flag), 1)
      }
      if (this.taskArr.length == 0) {
        this.getData()
      }
    },

    // #7135 , TabTool 监听 change 事件
    onTabToolChange(currentTab) {
      console.log('currentTab: ', currentTab)
    },
  },
  beforeDestroy() {
    //store中的除了状态(states)其他都不需缓存
    if (this.store) {
      this.store = {
        states: this.store.states,
      }
      delete this.store.states.provisional //删除页面切换时不需缓存的数据
    }
    // 销毁组件前判断当前页面是否还存活，存活缓存数据，被关闭了，就清除缓存
    this.$cfn.setLocalCacheMemory(`${this.currentRouter.id}`, this.$data, this)
  },
}
</script>
